import { render, staticRenderFns } from "./FinancialsItem.vue?vue&type=template&id=72a92024&scoped=true"
import script from "./FinancialsItem.vue?vue&type=script&lang=js"
export * from "./FinancialsItem.vue?vue&type=script&lang=js"
import style0 from "./FinancialsItem.vue?vue&type=style&index=0&id=72a92024&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a92024",
  null
  
)

export default component.exports